import { DatosFotosActualizar } from "@/erp/clientes/cliente-update-data/shared";
import { useUpdatePreventa } from "@/shared/actions/erp";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs"
import { AlertSeverityEnum } from "@/shared/interfaces";
import { useUiStore } from "@/store/ui";
import { Grid } from "@mui/material"
import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { UseFormReturn } from "react-hook-form";
import { useEditPendienteActualizarFotos } from "../hook/useEditPreventaFotos";

interface EditAgendamientoImagenProps {
  open: boolean
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
  form: UseFormReturn<any, any, any>;
}


export default function EditPreventaImagen({
  open,
  setOpen,
  form
}: EditAgendamientoImagenProps) {

  console.log(form.getValues(), 'form en edit imagen preventa');

  const queryClient = useQueryClient();

  const {
    imgCedulaFrontal, setImgCedulaFrontal,
    imgCedulaReverso, setImgCedulaReverso,
    imgCuentaBancaria, setCuentaBancaria,
    imgTarjeta, setImgTarjeta,
    imgRUC, setImgRUC,
    imgRUCNombramiento, setImgRUCNombramiento,

    handeleEditImagen
  } = useEditPendienteActualizarFotos({
    form
  })

  ///* Fetch y store
  const { mutateAsync: mutateAsyncPreventa } = useUpdatePreventa({})
  const setIsGlobalLoading = useUiStore(s => s.setIsGlobalLoading);
  const setAlert = useUiStore(s => s.setAlert);

  ///* handlers --------------------
  const onSave = async () => {
    setIsGlobalLoading(true);
    try {
      const dataSend = await handeleEditImagen()

      if (dataSend) {
        // Actualizar Preventa y Agendamiento
        await Promise.all([
          mutateAsyncPreventa({ id: form.getValues().id_preventa, data: dataSend }),
          //mutateAsyncAgendamiento({ id: form.getValues().id_agendamiento, data: dataSend }),
        ]);
      }

      setIsGlobalLoading(false);
      setOpen(false)
      queryClient.invalidateQueries({ queryKey: ['agendamientos'] });
      form.reset({})
    } catch (error) {
      setAlert(
        true,
        'Ocurrió un problema al cargar las imágenes, por favor, intente nuevamente.',
        AlertSeverityEnum.error,
        5000
      );
    } finally {
      setIsGlobalLoading(false);

    }
  };

  useEffect(() => {
    return () => {
      form.reset({})
    }
  }, [])


  return (
    open && (
      <ScrollableDialogProps
        onCloseIcon={() => {
          setOpen(false)
          form.reset({})
        }}
        open={open}
        title="Actualizar Imagen"
        minWidth="55%"
        onClose={() => {
          setOpen(false)
          form.reset({})
        }}
        confirmVariantBtn={'contained'}
        onConfirm={onSave}
        confirmTextBtn={'Actualizar'}
        showConfirmBtn={true}
        contentNode={
          <Grid container spacing={2}>

            <DatosFotosActualizar
              imgCedulaFrontal={imgCedulaFrontal}
              setImgCedulaFrontal={setImgCedulaFrontal}
              imgCedulaReverso={imgCedulaReverso}
              setImgCedulaReverso={setImgCedulaReverso}
              imgCuentaBancaria={imgCuentaBancaria}
              setCuentaBancaria={setCuentaBancaria}
              imgTarjeta={imgTarjeta}
              setImgTarjeta={setImgTarjeta}
              imgRUC={imgRUC}
              setImgRUC={setImgRUC}
              imgRUCNombramiento={imgRUCNombramiento}
              setImgRUCNombramiento={setImgRUCNombramiento}
              form={form}
            />

          </Grid>
        }
      />
    )

  )

}